<template>
  <home/>
</template>

<script>

  import Home from "./views/Home";

  export default {
    name: 'App',
    components: {Home},
    data: () => ({
      //
    }),
  };
</script>

<style lang="scss">
  .day {
    --divider: #c3cfdd;
    background-color: #fff;
    --text-primary: #111;
    --text-secondary: rgba(0, 0, 0, 0.6);
    --background-secondary: #eef0f3;
  }

  .night {
    --divider: #45484c;
    background-color: #1e272e;
    --text-primary: #dedede;
    --text-secondary: #bfbebe;
    --background-secondary: #2b343b;
  }

  body {
    font-family: 'Roboto', sans-serif;
    --action: #0489F3;
    --divider: #c3cfdd;

    h1, h2, h3, h4, h5, h6, p, span {
      color: var(--text-primary);
    }

    small {
      color: var(--text-secondary);
    }

  }
</style>
